const methods = {
    PUBLIC_URL: 'PUBLIC_URL',
    ADD_SYSTEM_FEEDBACK: 'ADD_SYSTEM_FEEDBACK',
    INIT_CONFIRM: 'INIT_CONFIRM',
    STORE_PAYLOAD_BEFORE_CONFIRM: 'STORE_PAYLOAD_BEFORE_CONFIRM',
    ADD_INSTRUCTION: 'ADD_INSTRUCTION',
    LOAD_INSTRUCTION: 'LOAD_INSTRUCTION',
    REMOVE_INSTRUCTION: 'REMOVE_INSTRUCTION',

    USER_LOGOUT: 'USER_LOGOUT',
    LOGOUT: 'LOGOUT',
    SWITCH_PAGE: 'SWITCH_PAGE',
    UPDATE_PROFILE: 'UPDATE_PROFILE',
    UPDATE_HUGS: 'UPDATE_HUGS',
    UPDATE_MSGS: 'UPDATE_MSGS',
    UPDATE_MATCHES: 'UPDATE_MATCHES',
    UPDATE_CONNECT_USERS: 'UPDATE_CONNECT_USERS',
    LOOP_CONNECT_USERS: 'LOOP_CONNECT_USERS',
    LOOP_CONNECT_USERS_SENDER_ID: 'LOOP_CONNECT_USERS_SENDER_ID',
    LOOP_CONNECT_USERS_RECEIVER_ID: 'LOOP_CONNECT_USERS_RECEIVER_ID'
}

export default methods